module.exports = __webpack_public_path__ + "img/avar.eda40d93.png";